<template>
  <div class="list-item" :class="[selected ? 'selected' : 'not-selected']">
    <span class="item-list"> {{ title }} </span>
  </div>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue'
interface PROPS {
  title: string
  selected: boolean
}
const props = defineProps<PROPS>()
const { title = 'No title', selected } = toRefs(props)
</script>

<style lang="scss" scoped>
@use '@/styles/variables.scss';
.list-item {
  cursor: pointer;
  border-radius: 2px;
  padding: 3px;
}

.not-selected {
  background-color: variables.$color-grey-lighter;
}

.selected {
  background-color: variables.$color-grey-darker;
  color: #fff;
}
</style>
